import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Integration.UsBank.Cancel.IRequest;
type Response = Api.Core.Integration.UsBank.Cancel.IResponse;
type Headers = Api.Core.Integration.UsBank.Cancel.IHeaders;
const url = '/api/UsBank/Payment/Cancel/:usBankCardId';
export default async function usBankCancelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
